import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { client } from '../../utils/contentfulClient';
import { Helmet } from 'react-helmet-async';

const POSTS_PER_PAGE = 6;

// REPLACE THIS WITH YOUR EXACT BRAND HEX CODE
const BRAND_COLOR = '#0'; 
const BRAND_HOVER = '#1a252f';

function BlogFeed() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPosts, setTotalPosts] = useState(0);

  useEffect(() => {
    setLoading(true);
    client.getEntries({ 
      content_type: 'blogPost',
      limit: POSTS_PER_PAGE,
      skip: (page - 1) * POSTS_PER_PAGE,
      order: '-sys.createdAt',
      // Tell Contentful to only return posts where Target Site is one of these two values:
      'fields.targetSite': process.env.REACT_APP_SITENAME
    })
      .then((response) => {
        setPosts(response.items);
        setTotalPosts(response.total);
        setLoading(false);
      })
      .catch(console.error);
  }, [page]);

  const totalPages = Math.ceil(totalPosts / POSTS_PER_PAGE);

  if (loading && posts.length === 0) return <p style={{ textAlign: 'center', marginTop: '50px', fontFamily: 'sans-serif', color: '#555' }}>Loading posts...</p>;

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 20px', fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' }}>
      <Helmet>
        <title>Blog | {process.env.REACT_APP_SITENAME}</title>
        <meta name="description" content="Read the latest updates and articles from {process.env.REACT_APP_SITENAME}}." />
      </Helmet>

      <h2 style={{ textAlign: 'center', marginBottom: '50px', color: '#222', fontSize: '2rem', fontWeight: '300', letterSpacing: '1px' }}>
        LATEST ARTICLES
      </h2>
      
      <div className="post-grid" style={{ display: 'grid', gap: '30px', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))' }}>
        {posts.map((post) => {
          const formattedDate = new Date(post.sys.createdAt).toLocaleDateString('en-GB', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          });

          return (
            <div key={post.sys.id} className="post-card" style={{ display: 'flex', flexDirection: 'column' }}>
              
              {post.fields.coverImage && (
                <img 
                  src={`https:${post.fields.coverImage.fields.file.url}?w=600&h=400&fit=fill`} 
                  alt={post.fields.coverImage.fields.title || post.fields.title} 
                  style={{ width: '100%', height: '200px', objectFit: 'cover', marginBottom: '20px' }}
                />
              )}

              <h3 style={{ marginTop: '0', marginBottom: '10px', fontSize: '1.4rem', color: '#222', fontWeight: '400' }}>
                {post.fields.title}
              </h3>
              
              <p style={{ textAlign: 'center', color: '#777', fontSize: '0.85rem', marginTop: '0', marginBottom: '15px', letterSpacing: '0.5px' }}>
                {formattedDate}
              </p>
              
              {/* Elegant Read Article button pushed to the bottom and centered */}
              <div style={{ marginTop: 'auto', paddingTop: '15px', textAlign: 'center' }}>
                <Link 
                  to={`/blog/${post.fields.slug}`} 
                  style={{ 
                    display: 'inline-block', 
                    textDecoration: 'none', 
                    color: '#fff', 
                    backgroundColor: 'black', 
                    margin: '20px auto',
                    padding: '10px 40px', 
                    fontFamily: 'Didot-W01-Italic, serif',
                    fontSize: '18px',                                        
                    transition: 'background-color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = BRAND_HOVER}
                  onMouseOut={(e) => e.target.style.backgroundColor = BRAND_COLOR}
                >
                  Read Article
                </Link>
              </div>
            </div>
          );
        })}
      </div>

      {/* Elegant Pagination Controls */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '30px', marginTop: '60px' }}>
          <button 
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            disabled={page === 1}
            style={{ 
              padding: '10px 20px', 
              cursor: page === 1 ? 'not-allowed' : 'pointer', 
              opacity: page === 1 ? 0.3 : 1, 
              border: `1px solid ${BRAND_COLOR}`, 
              backgroundColor: 'transparent',
              color: BRAND_COLOR,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              fontSize: '0.8rem'
            }}
          >
            &larr; Previous
          </button>
          
          <span style={{ color: '#555', fontStyle: 'italic' }}>
            Page {page} of {totalPages}
          </span>
          
          <button 
            onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={page === totalPages}
            style={{ 
              padding: '10px 20px', 
              cursor: page === totalPages ? 'not-allowed' : 'pointer', 
              opacity: page === totalPages ? 0.3 : 1, 
              border: `1px solid ${BRAND_COLOR}`, 
              backgroundColor: 'transparent',
              color: BRAND_COLOR,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              fontSize: '0.8rem'
            }}
          >
            Next &rarr;
          </button>
        </div>
      )}
    </div>
  );
}

export default BlogFeed;